import { compose } from 'ramda';
import { withProps } from 'recompose';

import connect from 'app/libs/connect';
import wrapIn from 'app/enhancers/wrapIn';
import { clientReturnUrl } from 'app/features/checkout/selectors';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import { UI } from 'app/features/success/heroBlock/components/HeroBlock';

const HeroBlock = compose(
  connect({ clientReturnUrl }),
  withProps({
    titleKey: 'migration_success_title',
    subtitleKey: 'migration_success_subtitle',
    buttonTextKey: 'migration_success_button',
    imageUrl: 'img/success/hime-migration-success.png',
    image2XUrl: 'img/success/hime-migration-success@2x.png',
  }),
  wrapIn(BlockWrapper),
)(UI);

export default HeroBlock;
